<template>
    <ModalFormCard class="lg:min-w-[800px] modal-default">
        <template #title>Invoice breakdown</template>

        <template #default="{ saving, errors }">
            <!-- px-4 lg:px-10 pt-6 lg:pt-8 -->
            <div class="" v-if="invoice !== null" :class="[invoice.payments.length == 0 ? 'pb-8' : '']">
                <p class="text-18 font-semibold">Your invoice</p>

                <div class="mt-6 flex items-center flex-col lg:flex-row">
                    <div class="w-[326px] shrink-0 flex items-center flex-col">
                        <p
                            class="text-32 lg:text-40 font-hero font-bold"
                            :class="{
                                'text-green-600': invoice.status == 'Paid',
                            }"
                        >
                            {{ $help.dp(invoice.total) }}
                        </p>

                        <div class="flex items-center mt-2" v-if="invoice.last_payment != null">
                            <div class="rounded-full w-6 h-6 flex items-center justify-center" :class="invoice.icon().class">
                                <component :is="invoice.icon().icon" class="w-4 h-4" />
                            </div>

                            <p class="text-14 text-grey-900 pl-2.5">{{ invoice.statusView() }}</p>
                        </div>

                        <button class="bg-black hover:black-on-white h-12 px-10 text-14 text-white font-bold mt-8" @click="download">
                            Download
                        </button>
                    </div>

                    <div class="h-[274px] w-px bg-grey-500 lg:block hidden" />

                    <div
                        class="w-full flex items-start flex-col lg:justify-center justify-start lg:px-14 border-t border-grey-500 lg:border-0 mt-10 lg:mt-0"
                    >
                        <p class="text-19 lg:text-24 font-bold font-hero pt-4 lg:pt-0" v-if="invoice.product_id != 2">
                            {{ invoice.plan.name }}
                        </p>
                        <p class="text-14 lg:text-15 text-grey-900 lg:pt-1.5 pt-0.5">
                            {{ $moment(invoice.ads_period_from).format('Do MMMM') }} -
                            {{ $moment(invoice.ads_period_to).format('Do MMMM YYYY') }}
                        </p>
                        <p class="text-15 font-semibold pt-2 lg:pt-3" v-if="invoice.product_id != 2">
                            {{ invoice.industry_name }} / {{ invoice.location_area }}
                        </p>
                    </div>
                </div>

                <div class="lg:mt-10 lg:-mx-6 mt-6 -mx-4 -mb-6" v-if="invoice.payments.length > 0">
                    <table class="w-full !mt-0">
                        <thead>
                            <tr class="bg-grey lg:h-16 h-12 text-left text-14 text-grey-900 !border-0 !items-center">
                                <th class="font-normal lg:pl-10 pl-4 !pb-0 !align-middle !border-0 !block lg:!table-cell">
                                    Payment history
                                </th>
                                <th class="font-normal !pb-0 !align-middle !border-0">Amount</th>
                                <th class="font-normal !pb-0 !align-middle !border-0">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="payment in invoice.payments" class="lg:h-20">
                                <td class="pl-4 lg:pl-10 w-6/5">
                                    <p class="text-15 lg:text-17 font-semibold">{{ $moment(payment.created_at).format('Do MMMM YYYY') }}</p>
                                    <p class='text-14 text-grey-900 w-fit'>{{ payment.fail_message || payment.seller_message }}</p>
                                </td>
                                <td class="text-right lg:text-left pr-4 lg:pr-0">
                                    <p class="text-15 lg:text-17 font-semibold">{{ $help.dp(invoice.total) }}</p>
                                </td>
                                <td class="px-4 lg:px-0 pt-4 lg:pt-0">
                                    <div class="flex items-center">
                                        <div class="rounded-full w-6 h-6 flex items-center justify-center" :class="payment.icon().class">
                                            <component :is="payment.icon().icon" class="w-4 h-4" />
                                        </div>

                                        <div class="pl-2.5">
                                            <p class="text-15 leading-4">{{ payment.icon().title }}</p>
                                            <p class="text-12 text-grey-900 leading-3 pt-1" v-if="payment.paid == 0">
                                                {{ payment.fail_message }}
                                            </p>
                                            <p class="text-12 text-grey-900 leading-3 pt-1" v-if="payment.paid == 1">
                                                <span class="uppercase">{{ payment.payment_method.brand }}</span> -
                                                {{ payment.payment_method.last_4 }} - {{ payment.payment_method.exp_month <= 9 ? '0' : ''
                                                }}{{ payment.payment_method.exp_month }}/{{
                                                    String(payment.payment_method.exp_year).slice(2, 4)
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Invoice from '~/models/invoice.js'
import Modal from '~/mixins/modal.js'
import { saveAs } from 'file-saver'

export default {
    mixins: [Modal],

    created() {
        this.setup(Invoice)
    },

    methods: {
        download() {
            this.$axios.get('/invoice/' + this.invoice.id).then(async (res) => {
                saveAs(res, 'Invoice-' + this.$moment(this.invoice.stripe_period_from).format('DD-MM-yyyy'))
            })
        },
    },

    computed: {
        invoice() {
            return this.editingModel
        },
    },
}
</script>
